module.exports = __webpack_public_path__ + "static/electricmotorcycleforum-7f4dc1aadadc903085838f08dce0ca25.webp";